import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home'); // Track the active section
  const location = useLocation();
  const navigate = useNavigate();

  const handleMenuClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, sectionId: string) => {
    e.preventDefault();
    setMenuOpen(false); // Close menu on click

    if (location.pathname !== '/') {
      // Navigate to the home page first
      navigate('/');
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
          setActiveSection(sectionId); // Update active section
        }
      }, 100); // Delay to ensure the home page is loaded
    } else {
      // Scroll directly if already on the home page
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
        setActiveSection(sectionId); // Update active section
      }
    }
  };

  useEffect(() => {
    const sections = document.querySelectorAll('section'); // Assuming each section has a <section> tag
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id); // Update active section when in view
          }
        });
      },
      { threshold: 0.6 } // Trigger when 60% of the section is visible
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect(); // Cleanup observer on component unmount
  }, []);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link
          to="/"
          className="brand-name"
          onClick={(e) => handleMenuClick(e, 'home')} // Scroll to the home section
        >
          Daksh Ravitaj
        </Link>
        <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          <Link
            to="/"
            className={activeSection === 'home' ? 'active' : ''}
            onClick={(e) => handleMenuClick(e, 'home')}
          >
            Home
          </Link>
          <Link
            to="/"
            className={activeSection === 'products' ? 'active' : ''}
            onClick={(e) => handleMenuClick(e, 'products')}
          >
            Products
          </Link>
          <Link
            to="/"
            className={activeSection === 'process' ? 'active' : ''}
            onClick={(e) => handleMenuClick(e, 'process')}
          >
            Process
          </Link>
          <Link
            to="/"
            className={activeSection === 'quality' ? 'active' : ''}
            onClick={(e) => handleMenuClick(e, 'quality')}
          >
            Quality
          </Link>
          <Link
            to="/"
            className={activeSection === 'about' ? 'active' : ''}
            onClick={(e) => handleMenuClick(e, 'about')}
          >
            About
          </Link>
          <Link
            to="/"
            className={activeSection === 'contact' ? 'active' : ''}
            onClick={(e) => handleMenuClick(e, 'contact')}
          >
            Contact
          </Link>
        </div>
        <div className="hamburger-menu" onClick={() => setMenuOpen(!menuOpen)}>
          ☰
        </div>
      </div>
    </nav>
  );
};

export default Navbar;